import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";
import Permission from "@/pcm/store/models/Permission";
import {find, isNil} from "lodash";
import Role from "@/pcm/store/models/Role";
import Contract from "@/pcm/store/models/Contract";

export default class User extends Model {
    static entity = 'users';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'name',
    };

    static fields() {
        return {
            id: this.uid(),
            avatar: this.string(''),
            name: this.string(''),
            email: this.string(''),
            email_verified_at: this.string(null).nullable(),
            preferred_color_scheme: this.string(null).nullable(),
            preferred_locale: this.string(null).nullable(),

            permissions: this.attr([]),
            roles: this.attr([]),
            contracts: this.hasMany(Contract, 'creator_id'),

            created_at: this.string(''),
            updated_at: this.string(''),
        }
    }

    declare id: number;
    declare name: string;
    declare email: string;
    declare email_verified_at: string | null;
    declare preferred_color_scheme: string | null;
    declare preferred_locale: string | null;
    declare permissions: Array<Permission>;
    declare roles: Array<Role>;
    declare contracts: Array<Contract>;

    hasPermissionTo(permission: string): boolean {
        return !isNil(find(this.permissions, ['name', permission]));
    }

    get initials() {
        const items = this.name
            .split(' ')
            .map(i => i.substring(0, 1));

        return (items[0] + (items.length > 1 ? items[items.length - 1] : '')).toUpperCase();
    }
}
